import { render, staticRenderFns } from "./GestioneAllegato.vue?vue&type=template&id=3fff3bc4&"
import script from "./GestioneAllegato.vue?vue&type=script&lang=js&"
export * from "./GestioneAllegato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports